/**
 * Staged rollout of in-doc ask (FEATURE_MANUAL_ASK), per the phased UI/UX plan
 * (docs/design/2026-07-01-cyclecare-manual-ask-phased-uiux-mock.html):
 *   1a 核心可用   — 2-action popover, anchor highlight, scope note
 *   1b 敢反复用   — first-touch hint, session persistence, per-turn source, stop/copy
 *   1c 全端可发   — mobile bottom-sheet dock, keyboard/screen-reader a11y
 *   2  顺藤摸瓜   — follow-up chips, scope switch, handoff to main chat
 * Stages are ordered and inclusive; the server exposes the configured stage in
 * /healthz (features.manualAskStage). Shared by the web UI and unit tests —
 * pure logic, no product knowledge.
 * Mirrored by the MANUAL_ASK_STAGE whitelist in server/config.ts — keep in sync.
 */
export const ASK_STAGES = ["1a", "1b", "1c", "2"] as const;
export type AskStage = (typeof ASK_STAGES)[number];

/** Unknown/missing input clamps to the minimum stage — never over-enables. */
export function normalizeAskStage(value: string | undefined): AskStage {
  return (ASK_STAGES as readonly string[]).includes(value ?? "") ? (value as AskStage) : "1a";
}

/** Is the current (possibly raw) stage at or above `min`? */
export function stageAtLeast(current: string | undefined, min: AskStage): boolean {
  return ASK_STAGES.indexOf(normalizeAskStage(current)) >= ASK_STAGES.indexOf(min);
}
